module.exports = __webpack_public_path__ + "img/LV1.9aa3431a.webp";